module.exports = __webpack_public_path__ + "img/ve2.783ded19.png";